import logo from './logo.svg';
import './App.css';
import React from 'react';
import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";


import Login from './components/login';
import Header from './components/header';
import Registration from './components/registration';
import Otp from './components/otp';
import { AppContext } from './context';

import Instruction from './components/instruction';
import Footer from './components/footer';
import HeaderForm from './components/headerform';
import Forms from './components/forms';
import Password from './components/password';
import Resetpassword from './components/resetpassword';
import Application from './components/application';
import Applicationstatus from './components/applicationstatus';
import Applicationstatusparent from './components/applicationstatusparent';

import FormStatus from './components/formstatus';
import StaffLogin from './components/stafflogin';
import AdminLogin from './components/adminlogin';
import PageNotFound from './components/PageNotFound';
import ApplicationFormsUploaded from './components/application_forms_uploaded';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Sidebar from './components/sidebar';
import UserListing from './components/userlisting';
import LocationListing from './components/locationlisting';
import StudentListing from './components/studentlisting';
import UserManagement from './components/admin/usermanagement';
import AdminLayout from './AdminLayout';
import RequireAuth from './middleware/RequireAuth';
import { useSelector } from 'react-redux';
import SidebarAdmin from './components/admin/sidebaradmin';

import AddLocation from './components/admin/addlocation';

import ManageLocation from './components/admin/managelocation';
import StudentManagement from './components/admin/studentmanagement';
import StudentDetails from './components/admin/studentdetails';
import ApplicationList from './components/admin/applicationlist';
import Report from './components/admin/report';
import Impersonate from './components/admin/impersonate';

import ResetStaffpassword from './components/resetstaffpassword';
function NoMatch() {
  return <Navigate to='/' />
}
function App() {
  var baseName = '/';
  var data = [];
  data.tabName = 'Learnbyrole';
  // data.imageUrl = process.env.REACT_APP_IMAGE_URL;
  data.backEndUrl = process.env.REACT_APP_BACKEND_URL + 'api/';
  data.imageEndUrl = process.env.REACT_APP_IMAGE_URL;

  const [storage, setStorage] = React.useState([
    data
  ]);

  const dispatchStorageEvent = (payload) => {
    setStorage(payload);

    return true;
  };

  const userdata = useSelector(state => state.userdata);

  return (

    <AppContext.Provider value={{ storage, dispatchStorageEvent }}>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />


      <BrowserRouter basename={baseName}>

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/header" element={<Header />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/otp" element={<Otp />} />

          <Route path="/instruction" element={<Instruction />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/headerform" element={<HeaderForm />} />
          <Route path="/forms" element={<Forms />} />
          <Route path="/password" element={<Password />} />
          <Route path="/resetpassword/:id" element={<Resetpassword />} />
          <Route path="/application" element={<Application />} />
          {/*<Route path="/applicationstatus" element={<Applicationstatus />} />*/}
          <Route path="/applicationstatus" element={<ApplicationFormsUploaded />} />
          {/*<Route path="/applications/forms-uploaded-list" element={<ApplicationFormsUploaded />} />*/}
          <Route path="/formstatus" element={<FormStatus />} />
          <Route path="/stafflogin" element={<StaffLogin />} />
          <Route path="/adminlogin" element={<AdminLogin />} />

          <Route path="/resetstaffpassword/:id" element={<ResetStaffpassword />} />
          {/* <Route element={<Layout  />}> */}
          <Route path="*" element={<PageNotFound />} />

          <Route element={<RequireAuth userdata={userdata} />} >
            <Route element={<AdminLayout />}>

              <Route path="/admin/usermanagement" element={<UserManagement />} />
              <Route path="/admin/userlisting" element={<UserListing />} />
              <Route path="/admin/locationlisting" element={<LocationListing />} />
              <Route path="/admin/studentlisting" element={<StudentListing />} />
              <Route path="/admin/sidebaradmin" element={<SidebarAdmin />} />
              <Route path="/admin/report" element={<Report />} />
              <Route path="/admin/addlocation" element={<AddLocation />} />
              <Route path="/admin/managelocation" element={<ManageLocation />} />
              <Route path="/admin/studentmanagement" element={<StudentManagement />} />
              <Route path="/admin/applicationlist" element={<ApplicationList />} />
              <Route path="/admin/studentdetails" element={<StudentDetails />} />
              <Route path="/admin/impersonate" element={<Impersonate />} />
            
              
            </Route>
          </Route>





        </Routes>
      </BrowserRouter>
    </AppContext.Provider >

  );
}

export default App;
